import { Component, OnInit } from '@angular/core';
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {paramsHelper} from "../../helpers/params-helper";
import {IDocument} from "../../interfaces/document.definition";
import {BusService} from "../../services/bus.service";

@Component({
  selector: 'app-go-tags-page',
  templateUrl: './go-tags-page.component.html',
  styles: []
})
export class GoTagsPageComponent implements OnInit {

  VAL_TYPES = VALUE_TYPE;

  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(false)
    .setTitle("Список тегов");

  document:IDocument;

  collectionParams = paramsHelper.collection()
    .setDuplicateEnabled(false)
    .setDefaultListLabels()
    .setItemLabelQuery('name')
    .setObjectType(DOCUMENT_TYPES.GO_TAG);

  constructor(private busService:BusService) { }

  ngOnInit() {
    this.busService.onDocumentUpdated
      .subscribe(e => this.updateDocument(e.document as IDocument));
  }

  private updateDocument(document:IDocument){
    this.document = document;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/go-tags-page/go-tags-page.component.ts